<script setup lang="ts">
const { t } = useI18n();

const emit = defineEmits<{
  (e: 'verify-click'): void;
}>();
</script>

<template>
  <div
    class="mt-7 flex flex-col gap-5 rounded-[18px] border border-success/30 bg-success/10 p-5 tablet:flex-row tablet:flex-wrap tablet:items-center tablet:justify-between tablet:gap-7 tablet:px-8 tablet:py-7"
  >
    <div class="flex min-w-0 flex-1 gap-[14px] tablet:gap-[18px]">
      <span
        class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-white text-success tablet:h-12 tablet:w-12 tablet:rounded-[12px]"
        aria-hidden="true"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 3l8 3v6c0 5-3.4 8.5-8 9.5C7.4 20.5 4 17 4 12V6l8-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      </span>
      <div class="min-w-0">
        <div class="mb-1 font-mono text-[10px] font-bold uppercase tracking-[0.1em] text-success">
          {{ t('property.access.registeredBottomVerifyBanner.badge') }}
        </div>
        <h3
          class="m-0 mb-1.5 text-balance font-serif text-[18px] font-semibold tracking-[-0.015em] text-black-100 tablet:text-[22px]"
        >
          {{ t('property.access.registeredBottomVerifyBanner.heading') }}
        </h3>
        <p class="m-0 max-w-[640px] text-[13px] leading-[1.5] text-black-70">
          {{ t('property.access.registeredBottomVerifyBanner.description') }}
        </p>
      </div>
    </div>
    <button
      type="button"
      class="inline-flex h-[48px] w-full shrink-0 items-center justify-center rounded-[12px] bg-black-100 px-6 text-[14px] font-bold text-white transition-colors hover:bg-black-90 tablet:h-[52px] tablet:w-auto tablet:text-[15px]"
      @click="emit('verify-click')"
    >
      <span
        >{{ t('property.access.shared.verifyThirtySec') }}
        <span
          class="inline-block rtl:-scale-x-100"
          aria-hidden="true"
          >→</span
        ></span
      >
    </button>
  </div>
</template>
